import { Component, OnInit, EventEmitter, Output, ViewEncapsulation, Input } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { RotinaCliente } from '../../comum/modelos/rotina-cliente';
import { ReincidenciaRotina } from '../../comum/modelos/reincidencia-rotina';

@Component({
    selector: 'app-modal-reincidencia-rotina',
    templateUrl: './modal-reincidencia-rotina.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./modal-reincidencia-rotina.component.css']
})
export class ModalReincidenciaRotinaComponent implements OnInit {

    @Output() reincidenciaRotinaEvent: EventEmitter<ReincidenciaRotina>;
    @Input() idRotinaCliente: number;
    @Input() origem: string;
    public reincidenciaRotina: ReincidenciaRotina;

    constructor(private modalService: NgbModal) {
        this.reincidenciaRotinaEvent = new EventEmitter<ReincidenciaRotina>();
        this.reincidenciaRotina = new ReincidenciaRotina();
    }

    cadastrar(content) {
        const ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'modalReincidenciaRotina',
            size: 'lg'
        };
        this.modalService.open(content, ngbModalOptions).result.then((result) => {
            this.reincidenciaRotina = result;
            this.reincidenciaRotinaEvent.emit(this.reincidenciaRotina);
        }, (reason) => {
        });
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/rotina/modal-reincidencia-rotina/modal-reincidencia-rotina.component.ts